import defaultLayout from '../../../layouts/default'

export default {
  path: 'colleague',
  component: defaultLayout,
  children: [
    {
      path: 'view',
      component: () => import('./view/colleague.vue'),
      meta: {
        activeMenu: 'colleague',
        auth: true
      }
    },
    {
      path: 'edit',
      component: () => import('./edit/colleagueEdit.vue'),
      meta: {
        activeMenu: 'colleague',
        auth: true
      }
    }
  ]
}
